import { render, staticRenderFns } from "./match-score.vue?vue&type=template&id=4dda64e0&scoped=true"
import script from "./match-score.vue?vue&type=script&lang=js"
export * from "./match-score.vue?vue&type=script&lang=js"
import style0 from "./match-score.vue?vue&type=style&index=0&id=4dda64e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda64e0",
  null
  
)

export default component.exports